import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRequestButtonState } from '../../types/requestButton/requestButtonState';

const initialState: IRequestButtonState = {
  loading: false,
};

export const requestButtonSlice = createSlice({
  name: 'requestButton',
  initialState,
  reducers: {
    toggleRequestButtonLoading: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        loading: action.payload,
      };
    },
  },
});

export const {
  reducer: requestButtonReducer,
  actions: { toggleRequestButtonLoading },
} = requestButtonSlice;
